import React, { useState, useEffect, useCallback } from 'react'

import isEqual from 'lodash/isEqual'
import { notify, secondToTime, getKeyCode } from 'utils'

import { Block } from './styles'

function getCurrentSubs(subs, beginTime, duration) {
  return subs.filter(item => {
    return (
      (item.startTime >= beginTime && item.startTime <= beginTime + duration) ||
      (item.endTime >= beginTime && item.endTime <= beginTime + duration) ||
      (item.startTime < beginTime && item.endTime > beginTime + duration)
    )
  })
}

function magnetically(time, closeTime) {
  if (!closeTime) return time
  if (time > closeTime - 0.1 && closeTime + 0.1 > time) {
    return closeTime
  }
  return time
}

let lastTarget = null
let lastSub = null
let lastType = ''
let lastX = 0
let lastIndex = -1
let lastWidth = 0
let lastDiffX = 0
let isDroging = false

export default React.memo(
  function({
    player,
    subtitles,
    render,
    currentTime,
    checkSubtitle,
    removeSubtitle,
    addSubtitle,
    hasSubtitle,
    mergeSubtitle,
    updateSubtitle,
  }) {
    const [contextMenu, setContextMenu] = useState(false)
    const [contextMenuX, setContextMenuX] = useState(0)
    const [contextMenuY, setContextMenuY] = useState(0)

    const $blockRef = React.createRef()
    const $contextMenuRef = React.createRef()
    const $subsRef = React.createRef()
    const currentSubs = getCurrentSubs(
      subtitles,
      render.beginTime,
      render.duration
    )
    const gridGap = document.body.clientWidth / render.gridNum
    const currentIndex = currentSubs.findIndex(
      item => item.startTime <= currentTime && item.endTime > currentTime
    )

    const onContextMenu = (sub, event) => {
      lastSub = sub
      event.preventDefault()
      const $subs = event.target
      const subsTop = $subs.getBoundingClientRect().top
      const $contextMenu = $contextMenuRef.current
      const top =
        event.pageY + $contextMenu.clientHeight > document.body.clientHeight
          ? document.body.clientHeight - $contextMenu.clientHeight - subsTop
          : event.pageY - subsTop
      const left =
        event.pageX + $contextMenu.clientWidth > document.body.clientWidth
          ? document.body.clientWidth - $contextMenu.clientWidth
          : event.pageX
      setContextMenuX(left)
      setContextMenuY(top)
      setContextMenu(true)
    }

    const onDocumentClick = useCallback(
      event => {
        if (event.composedPath) {
          const composedPath = event.composedPath() || []
          if (composedPath.includes($contextMenuRef.current)) {
            setContextMenu(false)
          }
        }
      },
      [$contextMenuRef, setContextMenu]
    )

    const onMouseDown = (sub, event, type) => {
      isDroging = true
      lastSub = sub
      lastType = type
      lastX = event.pageX
      lastIndex = currentSubs.indexOf(sub)
      lastTarget = $subsRef.current.children[lastIndex]
      lastWidth = parseFloat(lastTarget.style.width)
    }

    const onDocumentMouseMove = useCallback(event => {
      if (isDroging && lastTarget) {
        lastDiffX = event.pageX - lastX
        if (lastType === 'left') {
          lastTarget.style.width = `${lastWidth - lastDiffX}px`
          lastTarget.style.transform = `translate(${lastDiffX}px)`
        } else if (lastType === 'right') {
          lastTarget.style.width = `${lastWidth + lastDiffX}px`
        } else {
          lastTarget.style.transform = `translate(${lastDiffX}px)`
        }
      }
    }, [])

    const onDocumentMouseUp = useCallback(() => {
      if (isDroging && lastTarget && lastDiffX) {
        const timeDiff = lastDiffX / gridGap / 10
        const index = hasSubtitle(lastSub)
        const previou = subtitles[index - 1]
        const next = subtitles[index + 1]
        const startTime = magnetically(
          lastSub.startTime + timeDiff,
          previou ? previou.endTime : 0
        )
        const endTime = magnetically(
          lastSub.endTime + timeDiff,
          next ? next.startTime : 0
        )
        const width = (endTime - startTime) * 10 * gridGap

        // if (
        //   (previou && endTime < previou.startTime) ||
        //   (next && startTime > next.endTime)
        // ) {
        //   notify('Erro de parâmetro oi', 'error')
        // } else {
        if (lastType === 'left') {
          if (startTime >= 0 && startTime < lastSub.endTime) {
            const start = secondToTime(startTime)
            updateSubtitle(lastSub, 'start', start)
            player.seek = startTime
          } else {
            lastTarget.style.width = `${width}px`
            notify('Erro de parâmetro', 'error')
          }
        } else if (lastType === 'right') {
          if (endTime >= 0 && endTime > lastSub.startTime) {
            const end = secondToTime(endTime)
            updateSubtitle(lastSub, 'end', end)
            player.seek = startTime
          } else {
            lastTarget.style.width = `${width}px`
            notify('Erro de parâmetro', 'error')
          }
        } else {
          if (startTime > 0 && endTime > 0 && endTime > startTime) {
            const start = secondToTime(startTime)
            const end = secondToTime(endTime)
            updateSubtitle(lastSub, {
              start,
              end,
            })
            player.seek = startTime
          } else {
            lastTarget.style.width = `${width}px`
            notify('Erro de parâmetro', 'error')
          }
        }
      }
      if (lastTarget) {
        lastTarget.style.transform = `translate(0)`
      }
      // }

      lastType = ''
      lastX = 0
      lastWidth = 0
      lastDiffX = 0
      isDroging = false
    }, [gridGap, hasSubtitle, player, subtitles, updateSubtitle])

    const onKeyDown = useCallback(
      event => {
        const sub = currentSubs[lastIndex]
        if (sub && lastTarget) {
          const keyCode = getKeyCode(event)

          switch (keyCode) {
            case 37:
              updateSubtitle(sub, {
                start: secondToTime(sub.startTime - 0.0334001336),
                end: secondToTime(sub.endTime - 0.0334001336),
              })
              player.seek = sub.startTime - 0.0334001336
              break
            case 39:
              updateSubtitle(sub, {
                start: secondToTime(sub.startTime + 0.0334001336),
                end: secondToTime(sub.endTime + 0.0334001336),
              })
              player.seek = sub.startTime + 0.0334001336
              break
            case 8:
            case 46:
              removeSubtitle(sub)
              break
            default:
              break
          }
        }
      },
      [currentSubs, player, removeSubtitle, updateSubtitle]
    )

    useEffect(() => {
      document.addEventListener('click', onDocumentClick)
      document.addEventListener('mousemove', onDocumentMouseMove)
      document.addEventListener('mouseup', onDocumentMouseUp)
      window.addEventListener('keydown', onKeyDown)
      return () => {
        document.removeEventListener('click', onDocumentClick)
        document.removeEventListener('mousemove', onDocumentMouseMove)
        document.removeEventListener('mouseup', onDocumentMouseUp)
        window.removeEventListener('keydown', onKeyDown)
      }
    }, [onDocumentClick, onDocumentMouseMove, onDocumentMouseUp, onKeyDown])

    return (
      <Block ref={$blockRef}>
        <div ref={$subsRef}>
          {currentSubs.map((sub, key) => {
            return (
              <div
                className={[
                  'sub-item',
                  key === currentIndex ? 'sub-highlight' : '',
                  checkSubtitle(sub) ? 'sub-illegal' : '',
                ]
                  .join(' ')
                  .trim()}
                key={key}
                style={{
                  left:
                    render.padding * gridGap +
                    (sub.startTime - render.beginTime) * gridGap * 10,
                  width: (sub.endTime - sub.startTime) * gridGap * 10,
                }}
                onClick={() => {
                  setContextMenu(false)
                  if (player.duration >= sub.startTime) {
                    player.seek = sub.startTime + 0.001
                  }
                }}
                onContextMenu={event => onContextMenu(sub, event)}
              >
                <div
                  className="sub-handle"
                  style={{
                    left: 0,
                    width: gridGap,
                  }}
                  onMouseDown={event => onMouseDown(sub, event, 'left')}
                />
                <div
                  className="sub-text"
                  onMouseDown={event => onMouseDown(sub, event)}
                >
                  {sub.text.split(/\r?\n/).map((line, index) => (
                    <p key={index}>{line}</p>
                  ))}
                </div>
                <div
                  className="sub-handle"
                  style={{
                    right: 0,
                    width: gridGap,
                  }}
                  onMouseDown={event => onMouseDown(sub, event, 'right')}
                />
              </div>
            )
          })}
        </div>
        <div
          ref={$contextMenuRef}
          className="contextmenu"
          style={{
            visibility: contextMenu ? 'visible' : 'hidden',
            left: contextMenuX,
            top: contextMenuY,
          }}
        >
          <div
            className="contextmenu-item"
            onClick={() => {
              removeSubtitle(lastSub)
              setContextMenu(false)
            }}
          >
            <p>Deletar</p>
          </div>
          <div
            className="contextmenu-item"
            onClick={() => {
              addSubtitle(hasSubtitle(lastSub) + 1)
              setContextMenu(false)
            }}
          >
            <p>Inserir</p>
          </div>
          <div
            className="contextmenu-item"
            onClick={() => {
              mergeSubtitle(lastSub)
              setContextMenu(false)
            }}
          >
            <p>Editar</p>
          </div>
        </div>
      </Block>
    )
  },
  (prevProps, nextProps) => {
    return (
      isEqual(prevProps.subtitles, nextProps.subtitles) &&
      isEqual(prevProps.render, nextProps.render) &&
      prevProps.currentTime === nextProps.currentTime
    )
  }
)
